var _g, _g2, _circle, _g3, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicSyncCloudsmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 210,
    viewBox: "0 0 249 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1790_12812)",
    className: "animate-subtle-move"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.503 63.3269C141.319 63.3269 141.138 63.3364 140.956 63.3407C140.956 63.3361 140.956 63.3315 140.956 63.3269C140.956 47.1301 127.855 34 111.693 34C98.5692 34 87.4634 42.6587 83.7523 54.5866C80.9509 53.108 77.7621 52.267 74.3759 52.267C63.2447 52.267 54.2211 61.3104 54.2211 72.466C54.2211 74.2832 54.4645 76.0429 54.9136 77.7181C52.8917 76.818 50.6589 76.3077 48.3039 76.3077C39.2958 76.3077 31.9934 83.6261 31.9934 92.6538C31.9934 101.682 39.2958 109 48.3039 109H141.503C154.088 109 164.29 98.7758 164.29 86.1634C164.29 73.5511 154.088 63.3269 141.503 63.3269Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1790_12812)",
    className: "animate-subtle-move animation-delay-500"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.968 86.0256C124.124 86.0256 124.278 86.0338 124.433 86.0374C124.433 86.0335 124.432 86.0296 124.432 86.0256C124.432 72.2044 135.564 61 149.295 61C160.445 61 169.881 68.3887 173.034 78.5672C175.414 77.3055 178.124 76.5879 181.001 76.5879C190.458 76.5879 198.125 84.3049 198.125 93.8243C198.125 95.375 197.918 96.8766 197.536 98.3061C199.254 97.5381 201.151 97.1025 203.152 97.1025C210.805 97.1025 217.01 103.348 217.01 111.051C217.01 118.755 210.805 125 203.152 125H123.968C113.275 125 104.608 116.275 104.608 105.513C104.608 94.7502 113.275 86.0256 123.968 86.0256Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 101.5,
    r: 20.5,
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1790_12812)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 120,
    r: 42,
    fill: "white",
    stroke: "#F0F0F4",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1790_12812)",
    className: "animate-spin-pause",
    style: {
      transformOrigin: "50% 57%"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.859 100.883V115.437C147.859 115.93 147.719 116.422 147.438 116.773C147.016 117.406 146.313 117.758 145.539 117.758H131.336C130.703 117.758 130.141 117.547 129.648 117.125C129.227 116.703 128.945 116.07 128.945 115.508V113.187C128.945 112.555 129.227 111.992 129.648 111.57C130.07 111.148 130.703 110.867 131.266 110.937H137.875C134.711 107.422 130.141 105.453 125.43 105.594C117.766 105.594 111.367 110.305 110.102 116.844L109.891 117.969C109.609 119.234 108.414 120.078 107.148 119.797L105.672 119.516L104.898 119.375C104.266 119.305 103.773 118.953 103.352 118.461C102.93 117.969 102.859 117.336 103 116.703L103.211 115.578C105.109 105.734 114.461 98.5624 125.5 98.5624C131.055 98.5624 136.469 100.461 140.758 103.906V100.883C140.758 100.25 141.039 99.6874 141.461 99.2655C141.883 98.8436 142.516 98.5624 143.148 98.6327H145.469C146.102 98.6327 146.664 98.8436 147.156 99.2655C147.578 99.6874 147.859 100.25 147.859 100.883Z",
    fill: "#1CC5A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.367 116.844C146.945 117.477 146.242 117.828 145.469 117.828H131.336C130.703 117.828 130.141 117.617 129.648 117.195C129.227 116.773 128.945 116.141 128.945 115.578V113.258C128.945 112.625 129.227 112.063 129.648 111.641C130.07 111.219 130.703 110.938 131.266 111.008H137.875C134.711 107.492 130.141 105.523 125.43 105.664C117.766 105.664 111.367 110.375 110.102 116.914L109.891 118.039C109.609 119.305 108.414 120.148 107.148 119.867L105.672 119.586L104.898 119.445C104.266 119.375 103.773 119.023 103.352 118.531C102.93 118.039 102.859 117.406 103 116.773L103.211 115.648C108.414 101.164 125.641 102.008 125.641 102.008C140.055 102.008 147.367 116.844 147.367 116.844Z",
    fill: "#1CC5A0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.211 140.047V125.492C103.211 125 103.352 124.508 103.633 124.156C104.055 123.523 104.758 123.172 105.531 123.172H119.664C120.297 123.172 120.859 123.383 121.352 123.875C121.773 124.297 122.055 124.93 122.055 125.562V127.812C122.055 128.445 121.773 129.008 121.352 129.43C120.93 129.851 120.297 130.133 119.734 130.062H113.125C116.289 133.578 120.859 135.547 125.57 135.406C133.234 135.406 139.703 130.695 140.898 124.156L141.109 123.031C141.391 121.766 142.586 120.922 143.852 121.203L145.328 121.484L146.102 121.625C146.734 121.695 147.227 122.047 147.578 122.609C147.93 123.101 148.07 123.734 147.93 124.367L147.719 125.562C145.891 135.266 136.539 142.437 125.5 142.437C119.945 142.437 114.531 140.539 110.242 137.023V140.047C110.242 140.68 109.961 141.242 109.539 141.664C109.117 142.086 108.484 142.367 107.852 142.297H105.531C104.266 142.367 103.211 141.312 103.211 140.047Z",
    fill: "#1CC5A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.633 124.086C104.055 123.453 104.758 123.101 105.531 123.101H119.664C120.297 123.101 120.859 123.312 121.352 123.805C121.773 124.226 122.055 124.859 122.055 125.492V127.742C122.055 128.375 121.773 128.937 121.352 129.359C120.93 129.781 120.297 130.062 119.734 129.992H113.125C116.289 133.508 120.859 135.476 125.57 135.336C133.234 135.336 139.703 130.625 140.898 124.086L141.109 122.961C141.391 121.695 142.586 120.851 143.852 121.133L145.328 121.414L146.102 121.555C146.734 121.625 147.227 121.976 147.578 122.539C147.93 123.031 148.07 123.664 147.93 124.297L147.719 125.492C142.516 139.836 125.359 138.922 125.359 138.922C110.945 138.992 103.633 124.086 103.633 124.086Z",
    fill: "#1CC5A0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1790_12812",
    x: -0.0065918,
    y: 0,
    width: 196.296,
    height: 139,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1790_12812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1790_12812",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1790_12812",
    x: 72.6077,
    y: 27,
    width: 176.402,
    height: 128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1790_12812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1790_12812",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1790_12812",
    x: 61,
    y: 78,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1790_12812"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.564706 0 0 0 0 0.929412 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1790_12812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1790_12812",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1790_12812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(103 98)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicSyncCloudsmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_sync_clouds.min.f63d0fe5297f8fd53bcea913f6fdca9d.svg";